import { ActionDate } from "model/action-date.model";
import moment from "moment";
import { DateMaskEnum } from "common/enums/DateMaskEnum";

export interface ContactType {
  readonly id: number;
  readonly tarificationSessionId: string;
  readonly actionDate: ActionDate;
  readonly dto?: object;
}

export class Contact implements ContactType {
  readonly id: number;
  readonly tarificationSessionId: string;
  readonly actionDate: ActionDate;

  constructor(data?: ContactType) {
    this.id = -1;
    this.tarificationSessionId = "";
    this.actionDate = new ActionDate(
      moment().toDate(),
      DateMaskEnum.DDMMYYYYHHMMSS
    );
    if (data) {
      Object.assign(this, data);
    }
  }
}
